import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_FAILED,
  FETCH_NOTIFICATIONS_SUCCEED,
  FETCH_USER_NOTIFICATIONS,
  FETCH_USER_NOTIFICATIONS_FAILED,
  FETCH_USER_NOTIFICATIONS_SUCCEED,
  CHECKED_USER_NOTIFICATIONS,
  CHECKED_USER_NOTIFICATIONS_FAILED,
  CHECKED_USER_NOTIFICATIONS_SUCCEED,
  CHECKED_ALL_USER_NOTIFICATIONS,
  CHECKED_ALL_USER_NOTIFICATIONS_FAILED,
  CHECKED_ALL_USER_NOTIFICATIONS_SUCCEED,
  DELETE_USER_NOTIFICATIONS,
  DELETE_USER_NOTIFICATIONS_FAILED,
  DELETE_USER_NOTIFICATIONS_SUCCEED,
  DELETE_ALL_USER_NOTIFICATIONS,
  DELETE_ALL_USER_NOTIFICATIONS_FAILED,
  DELETE_ALL_USER_NOTIFICATIONS_SUCCEED,
  FETCH_MARKED_NOTIFICATIONS,
  FETCH_MARKED_NOTIFICATIONS_FAILED,
  FETCH_MARKED_NOTIFICATIONS_SUCCEED,
} from './action_types';

export default ({
  fetchNotifications: (params, callback) => ({
    type: FETCH_NOTIFICATIONS,
    params,
    callback,
  }),
  fetchNotificationsSucceed: (data, totalCount, callback) => ({
    type: FETCH_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  fetchNotificationsFailed: (err) => ({
    type: FETCH_NOTIFICATIONS_FAILED,
    err,
  }),

  fetchUserNotifications: (params, callback) => ({
    type: FETCH_USER_NOTIFICATIONS,
    params,
    callback,
  }),
  fetchUserNotificationsSucceed: (data, totalCount, callback) => ({
    type: FETCH_USER_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  fetchUserNotificationsFailed: (err) => ({
    type: FETCH_USER_NOTIFICATIONS_FAILED,
    err,
  }),

  // fetch marked all as read
  fetchMarkedNotifications: (params, callback) => ({
    type: FETCH_MARKED_NOTIFICATIONS,
    params,
    callback,
  }),
  fetchMarkedNotificationsSucceed: (data, totalCount, callback) => ({
    type: FETCH_MARKED_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  fetchMarkedNotificationsFailed: (err) => ({
    type: FETCH_MARKED_NOTIFICATIONS_FAILED,
    err,
  }),

  // check id
  checkedUserNotifications: (params, callback) => ({
    type: CHECKED_USER_NOTIFICATIONS,
    params,
    callback,
  }),
  checkedUserNotificationsSucceed: (data, totalCount, callback) => ({
    type: CHECKED_USER_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  checkedUserNotificationsFailed: (err) => ({
    type: CHECKED_USER_NOTIFICATIONS_FAILED,
    err,
  }),

  // check all
  checkedAllUserNotifications: (params, callback) => ({
    type: CHECKED_ALL_USER_NOTIFICATIONS,
    params,
    callback,
  }),
  checkedAllUserNotificationsSucceed: (data, totalCount, callback) => ({
    type: CHECKED_ALL_USER_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  checkedAllUserNotificationsFailed: (err) => ({
    type: CHECKED_ALL_USER_NOTIFICATIONS_FAILED,
    err,
  }),

  // delete id
  deleteUserNotifications: (params, callback) => ({
    type: DELETE_USER_NOTIFICATIONS,
    params,
    callback,
  }),
  deleteUserNotificationsSucceed: (data, totalCount, callback) => ({
    type: DELETE_USER_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  deleteUserNotificationsFailed: (err) => ({
    type: DELETE_USER_NOTIFICATIONS_FAILED,
    err,
  }),

  // delete all
  deleteAllUserNotifications: (params, callback) => ({
    type: DELETE_ALL_USER_NOTIFICATIONS,
    params,
    callback,
  }),
  deleteAllUserNotificationsSucceed: (data, totalCount, callback) => ({
    type: DELETE_ALL_USER_NOTIFICATIONS_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  deleteAllUserNotificationsFailed: (err) => ({
    type: DELETE_ALL_USER_NOTIFICATIONS_FAILED,
    err,
  }),

});
